import Promise from 'promise-polyfill'

const ApprovalType = {
  namespaced: true,
  state: {
    orgs: {},
    types: {}
  },
  mutations: {
    loadOrgs: (state, payload) => {
      state.orgs[payload.orgid] = Object.assign([], payload.data)
    },
    loadTypes: (state, payload) => {
      state.types[payload.id] = Object.assign([], payload.data)
    },
    reset: (state, payload) => {
      state.orgs = Object.assign({})
      state.types = Object.assign({})
    }
  },
  actions: {
    refreshByOrg: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.approvalType.getApprovalTypeByOrgUsingGET({orgid: payload.orgid})
          .then(res => {
            context.commit('loadOrgs', {orgid: payload.orgid, data: res.body})
            resolve(context.state.orgs[payload.orgid])
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    listByOrg: (context, payload) => {
      if (payload.orgid === undefined || payload.orgid === '') {
        return new Promise((resolve, reject) => {
          resolve([])
        })
      } else {
        if (context.state.orgs[payload.orgid] === undefined) {
          return context.dispatch('refreshByOrg', payload)
        } else {
          return new Promise((resolve, reject) => {
            if (context.state.orgs[payload.orgid] !== null) {
              resolve(context.state.orgs[payload.orgid])
            } else {
              reject(new Error('Cannot load approval types by Organization'))
            }
          })
        }
      }
    },
    refreshByTypeId: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.approvalType.getApprovalTypeListUsingGET({id: payload.id})
          .then(res => {
            context.commit('loadTypes', {id: payload.id, data: res.body})
            resolve(context.state.types[payload.id])
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    listByTypeId: (context, payload) => {
      if (payload.id === undefined || payload.id === '') {
        return new Promise((resolve, reject) => {
          resolve([])
        })
      } else {
        if (context.state.types[payload.id] === undefined) {
          return context.dispatch('refreshByTypeId', payload)
        } else {
          return new Promise((resolve, reject) => {
            if (context.state.types[payload.id] !== null) {
              resolve(context.state.types[payload.id])
            } else {
              reject(new Error('Cannot load approval types by id'))
            }
          })
        }
      }
    },
    reset: (context, payload) => context.commit('reset')
  }
}

export default ApprovalType



// WEBPACK FOOTER //
// ./src/store/master/ApprovalType.js